import { z } from "zod";
import { Schema } from "./prop-controllers";
const colorDataSchema = z.object({
  swatchId: z.string(),
  alpha: z.number()
});
const lengthDataSchema = z.object({
  value: z.number(),
  unit: z.enum(["px", "%"])
});
const gapDataSchema = z.object({
  value: z.number(),
  unit: z.literal("px")
});
const responsiveGapDataSchema = Schema.responsiveValue(gapDataSchema);
const fileIdSchema = z.string();
const imageDataV0Schema = fileIdSchema;
const imageDataV1MakeswiftFileSchema = z.object({
  version: z.literal(1),
  type: z.literal("makeswift-file"),
  id: z.string()
});
const imageDataV1ExternalFileSchema = z.object({
  version: z.literal(1),
  type: z.literal("external-file"),
  url: z.string(),
  width: z.number().nullable().optional(),
  height: z.number().nullable().optional()
});
const imageDataV1Schema = z.union([
  imageDataV1MakeswiftFileSchema,
  imageDataV1ExternalFileSchema
]);
const imageDataSchema = z.union([imageDataV0Schema, imageDataV1Schema]);
const responsiveNumberValueSchema = Schema.responsiveValue(z.number());
const responsiveSelectValueSchema = Schema.responsiveValue(z.string());
const responsiveIconRadioGroupValueSchema = Schema.responsiveValue(
  z.string()
);
export {
  colorDataSchema,
  gapDataSchema,
  imageDataSchema,
  imageDataV0Schema,
  imageDataV1Schema,
  lengthDataSchema,
  responsiveGapDataSchema,
  responsiveIconRadioGroupValueSchema,
  responsiveNumberValueSchema,
  responsiveSelectValueSchema
};
//# sourceMappingURL=data.js.map